import { call, put, takeLatest } from 'redux-saga/effects';
import apiCall from '../helpers/ApiCall';
import apiRoot from '../consts/apiRoot';
import { FETCH_DESIGN, FETCH_DESIGN_SUCCESS, FETCH_DESIGN_FAIL } from '../redux/Design';
import { GET } from '../consts/Methods';

function* fetchDesignFlow() {
  try {
    const endpoint = `${apiRoot}/designs`;
    const response = yield call(apiCall, { method: GET, endpoint, });
    yield put(FETCH_DESIGN_SUCCESS(response));
  } catch (error) {
    yield put(FETCH_DESIGN_FAIL(error));
  }
}

export default function* FetchDesignFlow() {
  yield takeLatest(FETCH_DESIGN, fetchDesignFlow);
}
